import React from 'react';
import { Link, NavLink } from 'react-router-dom';

const ForgotPassword = () => {
  return (
    <div className="create-password-page js-pg-hg mt-5">
      <div className="container">
        <div className="row align-items-center justify-content-center mt-5">
        <div class="col-xl-4 col-lg-6 col-md-8 col-sm-8 col-11 mt-5 mt-xl-0">
        <div class="card shadow-sm d-flex mt-5 mt-xl-0 bx-center border-0 p-4">
              <div class="card-body">
              <NavLink to="/LoginPage" className='btn m-0 p-0 btn-link text-decoration-none mb-4 text-primary'><i class='bx me-1 mt-2 text-primary bx-left-arrow-alt' ></i> Back to Login</NavLink>
                <form>
                  <h4>Forget Password</h4>
                  <label>Lost your password? Please Enter your email address. You will receive a link to create a new password via email</label>
                  <div className="mt-4">
                    <div className="form-group mb-4">
                      <label for="New Password" className="form-label">Work Email Address <span className='red'>*</span></label>
                      <input class="form-control"  type="email" placeholder="Enter email address" />
                    </div>
                  </div>
                  <Link to="/create-password" className="btn btn-md px-5 py-3 w-100 mt-2 btn-primary" type="submit">Send Reset Link</Link>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
